import React from "react";
import Layout from "../layouts/zh";
import SEO from "../components/seo";
import PayByPoints from "../components/TWComponents/PayByPoints";
import langData from "../data/static-pages/pages/pay-with-points/zh";

const PayByPointsPage = (props) => {
  const [openMobileNav, setOpenMobileNav] = React.useState(false);
  const [openWidget, setOpenWidget] = React.useState(false);

  const openWidgetAction = () => {
    setOpenWidget(!openWidget);
  };

  return (
    <Layout
      location={props.location}
      showBookNowButton={false}
      mobileWidgetStatus={openWidget}
      setMobileWidgetStatus={setOpenWidget}>
      <SEO
        title="Pay with Points"
        keyword="Pay with Points"
        decription="Pay with Points"
      />
      <PayByPoints
        openWidgetAction={openWidgetAction}
        langData={langData}
        locale="zh"
        tnclink="https://rewards.ayana.com/zh/terms-and-conditions-8"
      />
    </Layout>
  );
};

export default PayByPointsPage;
